import { z } from "zod";

export const OpaqueIdSchema = z
  .string()
  .min(5)
  .max(128)
  .regex(/^[a-z][a-z0-9_]*$/, "Expected an opaque platform ID");

export const UsernameSchema = z
  .string()
  .trim()
  .min(3)
  .max(64)
  .regex(
    /^[a-zA-Z0-9._@-]+$/,
    "Use letters, numbers, dots, dashes, underscores, or an email address",
  )
  .transform((value) => value.toLowerCase());

export const PasswordSchema = z
  .string()
  .min(8)
  .max(1024)
  .refine(
    (password) => new TextEncoder().encode(password).byteLength <= 1024,
    "Password is too long",
  );

export const PlatformRoleSchema = z.enum(["platform_admin", "organization_admin", "member"]);

export const UserSummarySchema = z.strictObject({
  id: OpaqueIdSchema,
  username: UsernameSchema,
  displayName: z.string().min(1).max(120),
});
